const RemoteStore = require('./remote-store').default;

module.exports = function(collection) {

	let listingCache;

	const parse = function(name) {
		const data = {};
		const parts = name.split('/');
		for (const part of parts) {
			const [ key, value ] = part.split('=');
			data[key] = decodeURIComponent(value);
		}
		return data;
	}

	this.allStores = async function() {
		if (!listingCache) {
			listingCache = RemoteStore.list(`collection=${collection}/`, 'public', 250);
		}
		return listingCache;
	}

	this.getIndex = async function(query, after, pageSize) {
		const items = (await this.allStores()).map(store => parse(store.name));

		const startIndex = items.findIndex(
			i => String(i.$id).toLowerCase() > String(after || '').toLowerCase()
		);

		if (startIndex < 0) return [];

		const endIndex = startIndex + pageSize;
		return items.slice(startIndex, endIndex);
	};

	this.getStore = async function(id) {
		const stores = await this.allStores();
		return stores.filter(s => s.name.includes(`$id=${id}`)).shift();
	}

	this.getName = async function(id) {
		const store = await this.getStore(id);
		return store && parse(store.name).name;
	}

	this.get = async function(id) {
		const store = await this.getStore(id);
		const item = store && await store.get();

		// we fix ID's and other core fields if the item is corrupt. this allows
		// callers to perform their own validation and deletion if needed. else,
		// callers may need to track id's separately, whereas we want callers
		// to assume some level of *basic* consistency.
		if (item) {
			return {
				...item,
				...parse(store.name)  // extract/inject hive format attributes
			}
		} else {
			return null;
		}
	}; // getItem()

};